import { ViewCondition, FilterGroup, FilterCondition, CustomView } from 'types/userConfig/userConfig';
import { mapFieldToApiField } from './field-mapping';

/**
 * בודק אם אובייקט הוא FilterGroup (מבנה חדש)
 */
export function isFilterGroup(filter: any): filter is FilterGroup {
  return filter && Array.isArray(filter.conditions) && filter.conditions.length > 0 && filter.conditions[0].hasOwnProperty('operator');
}

/**
 * ממיר ViewCondition ישן ל-FilterCondition חדש
 */
function convertViewConditionToFilterCondition(viewCondition: ViewCondition): FilterCondition {
  // מיפוי operator לפי סוג הערך
  let operator: FilterCondition['operator'] = 'eq';
  
  // אם הערך הוא null או undefined, נשתמש ב-isnull
  if (viewCondition.value === null || viewCondition.value === undefined) {
    operator = 'isnull';
  } else if (Array.isArray(viewCondition.value)) {
    operator = 'in';
  } else if (typeof viewCondition.value === 'string') {
    operator = 'contains';
  } else if (typeof viewCondition.value === 'boolean') {
    operator = 'eq';
  } else if (typeof viewCondition.value === 'number') {
    operator = 'eq';
  }

  return {
    id: viewCondition.id,
    field: mapFieldToApiField(viewCondition.key),
    operator,
    value: viewCondition.value,
  };
}

/**
 * ממיר תצוגה מותאמת ישנה למבנה החדש
 */
export function migrateCustomView(customView: CustomView): CustomView {
  // אם כבר במבנה החדש (יש FilterGroup), החזר כפי שהוא
  if (customView.filters.length > 0 && 'conditions' in customView.filters[0]) {
    return customView;
  }

  // המרת ViewCondition[] ל-FilterGroup[]
  const filterGroups: FilterGroup[] = [];
  
  if (customView.filters.length > 0) {
    // המרת כל התנאים הישנים לקבוצה אחת עם AND
    const conditions: FilterCondition[] = (customView.filters as ViewCondition[]).map(
      convertViewConditionToFilterCondition,
    );

    if (conditions.length > 0) {
      filterGroups.push({
        id: Date.now(),
        logic: 'and',
        conditions,
      });
    }
  }

  return {
    ...customView,
    filters: filterGroups,
    filtersLogic: 'and', // ברירת מחדל
  };
}

/**
 * ממיר את כל התצוגות המותאמות למבנה החדש
 */
export function migrateAllCustomViews(customViews: CustomView[]): CustomView[] {
  return customViews.map(migrateCustomView);
}

